export function voiceModeChange(status){
    return {type:'VOICE_MODE_CHANGE', payload: {status}};
}